export class CalculateItemWeightParamters{
    unitSystem?: string;
    quantity?: number; 
    quantityUom?: string; 
    totalWeightUom?: string; 
    od?: number; 
    odUom?: string; 
    odToleranceMinus?: number;
    odTolerancePlus?: number;
    odToleranceUom?: string; 
    wt?: number;
    wtUom?: string;
    id?: number; 
    idUom?: string; 
    idToleranceMinus?: number;
    idTolerancePlus?: number;
    idToleranceUom?: string; 
    npsScheduleId?: number | null; 
    rawMaterialGradeId?: number; 
    smsId?: number;
    typeOfTolerance?: string; 
    tubeExecutionId?: number; 
    wtToleranceMinus?: number;
    wtTolerancePlus?: number;
    wtToleranceUom?: string; 
    lengthType?: string; 
    lengthMin?: number; 
    lengthMax?: number;
    lengthUom?: string;
    lengthNominal?: number;
    uBent?: boolean;
    multipleLength?: boolean
}